import { Icon } from '@octano/global-ui';
import Tooltip, { TooltipProps } from './Tooltip';

type TooltipForSelectProps = TooltipProps & {
  isClearable?: boolean;
  hasValue?: boolean;
  marginRight?: number;
};

const TooltipForSelect = ({
  children,
  placement = 'bottom',
  isClearable = false,
  hasValue = false,
  marginRight = 65,
  ...props
}: TooltipForSelectProps) => {
  return (
    <div className="w-100 d-flex align-items-center justify-content-end">
      <div className="w-100">{children}</div>
      <div
        className={`d-flex align-items-center justify-content-center position-absolute mb-3 ${
          !isClearable || !hasValue ? 'mr-5' : ''
        }`.trim()}
        style={isClearable && hasValue ? { marginRight } : undefined}
      >
        <Tooltip placement={placement} {...props}>
          <Icon name="information" />
        </Tooltip>
      </div>
    </div>
  );
};

export default TooltipForSelect;
